<template>
  <div class="select-none">
    <label
      for="user-select"
      class="block mb-1.5 text-sm font-medium text-neutral-900"
    >
      Afløser
    </label>
    <select
      id="user-select"
      v-model="selectedUserId"
      @change="onUserChange"
      class="bg-white border border-neutral-300 text-neutral-900 text-sm rounded-lg focus:ring-neutral-500 focus:border-neutral-500 block w-full p-2.5"
    >
      <option value="" disabled>Vælg en afløser</option>
      <option
        v-for="user in users"
        :key="user.id"
        :value="user.id"
      >
        {{ user.first_name }} {{ user.last_name }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";

const props = defineProps({
  users: {
    type: Array,
    required: true,
  },
});

const emits = defineEmits(["user-selected"]);

const selectedUserId = ref("");

// Method to handle user change
const onUserChange = () => {
  const selectedUser = props.users.find(user => user.id === selectedUserId.value);
  if (selectedUser) {
    emits("user-selected", selectedUser);
  }
};

// Reset selection when users prop changes
watch(() => props.users, () => {
  selectedUserId.value = "";
});
</script>

<style scoped>
select option[value=""][disabled] {
  display: none;
}
</style>